import { render, staticRenderFns } from "./DigitalLearn.vue?vue&type=template&id=5dc38c41&scoped=true&"
import script from "./DigitalLearn.vue?vue&type=script&lang=js&"
export * from "./DigitalLearn.vue?vue&type=script&lang=js&"
import style0 from "./DigitalLearn.vue?vue&type=style&index=0&id=5dc38c41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc38c41",
  null
  
)

export default component.exports